import { ToastContainer, toast } from "react-toastify";
import {
  Grid,
  TextField,
  Button,
  Autocomplete,
  Tooltip,
  createFilterOptions,
  IconButton,
  useTheme,
  Typography,
  Dialog,
  Box,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";

import React, { useEffect, useState } from "react";
import { CloseIcon, Loginimg, PinImage, Uplodeimg } from "../../Assets/Icon";

import { Link, useNavigate } from "react-router-dom";
import { useRef } from "react";
import JoditEditor from "jodit-react";
import { Close } from "@mui/icons-material";
import {
  DesktopDateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import ImageIcon from "@mui/icons-material/Image";
import FileAttachment from "../../Components/FileAttachment";

function EmailToTicketForm() {
  const queryParams = new URLSearchParams(window.location.search);
  const qData = queryParams.get("q");
  const [mailData, setMaiData] = useState({});
  const config = global.$userData?.logindata?.crm_app_license_master;
  //UseStates
  const [company, setCompany] = useState(null);
  const [companyDrop, setCompanyDrop] = useState([]);
  const [contact, setContact] = useState(null);
  const [contactDrop, setContactDrop] = useState([]);
  const [Department, setDepartment] = useState(null);
  const [tickettype, settickettype] = useState(
    config?.internal_ticket == "Yes" ? "Internal" : "External"
  );
  const [DepartDrop, setDepartDrop] = useState([]);
  const [ticketSource, setTicketSource] = useState({
    TicketSourceId: 5,
    TicketSourceName: "Call",
  });

  const [refresh, setRefresh] = useState(false);

  const [ticketDrop, setTicketDrop] = useState([]);
  const [Product, setProduct] = useState(null);
  const [productDrop, setProductDrop] = useState([]);
  const [IssueDrop, setIssueDrop] = useState([]);
  const [Issues, setIssues] = useState(null);

  const [AttachmentLink, setAttachmentLink] = useState([]);
  const [Attachementlinksobj, setAttachmentLinkobj] = useState([]);

  const filter = createFilterOptions();
  const [selected, setSelected] = useState([]);
  const [options, setOptions] = useState([]);
  const [assign, setAssign] = useState(null);
  const [assignId, setAssignId] = useState("");
  const [assignDrop, setAssignDrop] = useState([]);
  const [TimeError, setTimeError] = useState(null);
  const [DT, setDT] = useState(dayjs().add(5, "minute"));

  // Format the date using dayjs format function
  const formattedDate = DT.format("YYYY-MM-DD HH:mm");
  /* Jodit Editor*/
  const editor = useRef(null);
  const [content, setContent] = useState("");

  //buttondisable
  const [Buttondisable, SetButtondisable] = useState(false);
  const [loading, setLoading] = useState(false);

  const Navigate = useNavigate();

  const handleDepartment = (val) => {
    setDepartment(val);
  };

  const handleProduct = (val) => {
    setProduct(val);
  };

  const handleIssues = (val) => {
    setIssues(val);
  };

  const companyList = async (AppCode, AccountsId) => {
    const response = await global.$axios
      .get(`/ticket/companies/${AppCode}`)
      .then(async (response) => {
        let company = response.data.Message;
        setCompanyDrop(response.data.Message);
        let getCompany = company.filter(
          (item) => item.AccountsId == AccountsId
        )[0];
        setCompany(getCompany);
      })
      .catch((e) => {
        console.log("Company List Issue", e);
      });
  };

  const contactList = async (AppCode, AccountId) => {
    if (!AccountId) {
      setContactDrop([]);
      setContact(null);
      setProductDrop([]);
      setProduct(null);
    } else {
      const response = await global.$axios
        .get(`/ticket/contacts/${AppCode}/${AccountId}`)
        .then(async (response) => {
          setContactDrop(response.data.Message);
          productList(AppCode, response.data.Message[0].ContactId);
          setContact(response.data.Message[0]);
        })
        .catch((e) => {
          console.log("Contact List Issue", e);
        });
    }
  };

  const ticketList = async (AppCode, source) => {
    const response = await global.$axios
      .get(`/source/activelist/${AppCode}`)
      .then(async (response) => {
        setTicketDrop(response.data.Message);
        let value = response.data.Message.findIndex(
          (x) => x.TicketSourceName == source?.TicketSourceName ?? ""
        );
        if (value != -1) {
          setTicketSource(response.data.Message[value]);
        } else {
          setTicketSource(response.data.Message[0]);
        }
      })
      .catch((e) => {
        console.log("Ticket Source Issue", e);
      });
  };

  const departmentList = async (AppCode) => {
    const response = await global.$axios
      .get(`ticket/department/${AppCode}`)
      .then(async (response) => {
        setDepartDrop(response.data.Message);
      })
      .catch((e) => {
        console.log("Department List Issue", e);
      });
  };

  const productList = async (AppCode, ContactId) => {
    if (!ContactId) {
      setProductDrop([]);
      setProduct(null);
    } else {
      const response = await global.$axios
        .get(`/ticket/products/${AppCode}/${ContactId}`)
        .then(async (response) => {
          setProductDrop(
            response.data.Message.length > 0 ? response.data.Message : []
          );
          setProduct(response?.data?.Message[0]);
        })
        .catch((e) => {
          console.log("Product List Issue", e);
        });
    }
  };

  const issueList = async (AppCode, deptid) => {
    if (!deptid) {
      setIssueDrop([]);
      setIssues(null);
      return;
    } else {
      const response = await global.$axios
        .get(`/ticket/issue/${AppCode}/${deptid}`)
        .then(async (response) => {
          setIssueDrop(response.data.Message);
          setIssues(null);
        })
        .catch((e) => {
          console.log("Issue List Issue", e);
        });
    }
  };

  const assignList = async (AppCode, deptid) => {
    if (!deptid) {
      setAssignDrop([]);
      setAssign(null);
    } else {
      const response = await global.$axios
        .get(`/ticket/assignto/${AppCode}/${deptid}`)
        .then(async (response) => {
          setAssignDrop(response.data.Message);
          setAssign(null);
        })
        .catch((e) => {
          console.log("Assign List Issue", e);
        });
    }
  };

  //ETC
  const ETC = async (AppCode, IssueId) => {
    const response = await global.$axios.post(`/ticket/getetc`, {
      AppCode: AppCode,
      IssueId: IssueId,
      FuctionFor: "Ticket",
      DepartmentId: Department?.DepartmentId,
    });
    if (response.data.Status === 200) {
      const res = dayjs(response.data.Message);
      console.log("res", res);
      setDT(res);
    }
  };

  //Tag
  const TagArray = selected.map((e) => e.TagId);
  const AddTag = async (AppCode) => {
    let data = {
      AppCode: AppCode,
      TagName: selected,
      UserId: mailData.emailuser?.userId,
    };
    const response = await global.$axios.post("/ticket/tag/add", data);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      AddTag(mailData?.AppCode);
    }
  };

  const TagList = async () => {
    const response = await global.$axios.get("/ticket/tag/activelist/1");
    setOptions(response.data.Message);
  };

  const ClosecreateTicket = async () => {
    setTimeout(() => {
      SetButtondisable(false);
    }, 5000);
    if (mailData.S3file) {
      setAttachmentLink([...AttachmentLink, mailData.S3file]);
    }
    if (
      !(company != null && Object.values(company).length !== 0) ||
      !(contact != null && Object.values(contact).length !== 0) ||
      !(Department != null && Object.values(Department).length !== 0) ||
      !(Issues != null && Object.values(Issues).length !== 0) ||
      !(assign != null && Object.values(assign).length !== 0) ||
      content === ""
    ) {
      toast.error(`You Missed Required Fields`);
      return;
    } else if (TimeError) {
      toast.error("Please Provide Valid Time");
      return;
    } else {
      let data = {
        AppCode: mailData.AppCode,
        AccountId: company?.AccountsId,
        ContactId: contact?.ContactId,
        DepartmentId: Department?.DepartmentId,
        IssueId: Issues.IssueId,
        AssignedTo: assignId,
        Tags: TagArray,
        ECAt: formattedDate,
        AttachmentFile: AttachmentLink,
        TicketDescription: content,
        RecordId: "",
        ProductId: Product?.ProductId,
        TicketSourceId: ticketSource?.TicketSourceId,
        TIcketShow: "",
        TicketOwner: assign?.UserId,
        UserId:
          mailData?.For == "2"
            ? mailData?.emailcontact?.ContactId
            : mailData.emailuser?.UserId,
        emailhtmltag: mailData.Htmltag,
      };
      const response = await global.$axios
        .post("ticket/create", data)
        .then(async (response) => {
          if (response.data.Status == 200) {
            toast.success("Ticket Created Successfully");
            let payload1 = {
              AppCode: mailData.AppCode,
              EmailticketId: mailData.EmailticketId,
            };
            console.log("payload1", payload1);

            const romovelist = await global.$axios.post(
              "ticket/updateemailstatus",
              payload1
            );

            console.log("EmailticketId", mailData.EmailticketId);
            console.log("romovelist", romovelist.data);

            return setTimeout(() => {
              Redirect();
            }, 1500);
          } else {
            toast.error("something went wrong");
          }
        })
        .catch((e) => {
          toast.error("Something Went Wrong");
        });
    }
  };

  const Redirect = () => {
    console.log("User Agent:", navigator.userAgent);

    const isMobile = /Android|iPhone|iPad/i.test(navigator.userAgent);

    const whatsappUrl = `https://wa.me/${mailData.whatsappNo}?text`;

    if (isMobile) {
      // Try to open the app with the universal wa.me link
      window.location.href = whatsappUrl;
    } else {
      // Desktop will open WhatsApp Web
      window.open(whatsappUrl, "_blank");
    }
  };

  const getTicketDetails = async () => {
    try {
      setLoading(true);
      const response = await global.$axios.get(
        `ticket/getcodemailtickets/${qData}`
      );
      // console.log("getTicketDetails", response.data);

      if (response.data.Status == 200) {
        let mailData = response.data.Message;
        setMaiData(mailData);
        companyList(mailData.AppCode, mailData.emailaccount.AccountsId);
        ticketList(mailData.AppCode, mailData.source);
        departmentList(mailData.AppCode);
        TagList();
        contactList(mailData.AppCode, mailData?.emailaccount?.AccountsId);
        setContent(mailData?.Htmltag ?? mailData?.Summary);
        if (mailData.For == "2") {
          setCompany(mailData?.emailaccount);

          setContact(mailData?.emailcontact);
          settickettype("External");
          if (mailData.S3file) {
            setAttachmentLink([mailData.S3file]);
            setAttachmentLinkobj([
              {
                filename: mailData.Filename,
                s3path: mailData.S3file,
              },
            ]);
          }
        } else {
          if (mailData.S3file) {
            setAttachmentLink([mailData.S3file]);
            setAttachmentLinkobj([
              {
                filename: mailData.Filename,
                s3path: mailData.S3file,
              },
            ]);
          }
        }
      }
    } catch (error) {
      console.error("ticket/getcodemailtickets", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  useEffect(() => {
    getTicketDetails();
  }, [qData]);

  return (
    <>
      <Grid container justifyContent="center" alignItems="start">
        {/* Header */}
        <Grid
          item
          xs={12}
          md={4}
          sm={6}
          sx={{
            maxHeight: "95vh",
            borderRadius: "10px",
            border: "1px solid #23232350",
            display: "flex",
            flexDirection: "column",
            margin: "10px",
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              background: "#0275F6",
              height: "10vh",
              alignItems: "center",
              gap: "16px",
              padding: "10px",
              borderTopRightRadius: "10px",
              borderTopLeftRadius: "10px",
            }}
          >
            <Loginimg height={24} width={24} />
            <Typography
              sx={{ fontSize: "16px", color: "#fff", fontWeight: 600 }}
            >
              Email To Ticket
            </Typography>
          </Grid>
          {loading ? (
            <Grid
              item
              xs={12}
              sx={{
                textAlign: "center",
                padding: "10px",
                height: "90vh",
                minHeight: "90vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
            </Grid>
          ) : mailData.Status == "pending" ? (
            <Grid
              item
              xs={12}
              sx={{
                maxHeight: "98vh",
                display: "flex",
                flexDirection: "column",
                overflowY: "scroll",
                margin: "5px",
              }}
            >
              <Grid
                container
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  margin: "10px 0px 0px 0px",
                  padding: "0px 10px",
                }}
              >
                {/* {tickettype == "External" && ( */}
                <>
                  <Grid item xs={12} style={{ marginBottom: "5px" }}>
                    <span style={{ fontSize: "14px", fontWeight: 500 }}>
                      Company Name
                    </span>
                    <span style={{ color: "darkred", paddingLeft: "2px" }}>
                      *
                    </span>

                    <Autocomplete
                      disabled={mailData?.For == "2"}
                      id="auto-complete"
                      size="small"
                      options={companyDrop}
                      value={company}
                      onChange={(event, newValue) => {
                        if (!newValue) {
                          contactList(null);
                        } else {
                          contactList(mailData.AppCode, newValue?.AccountsId);
                        }
                        setCompany(newValue);
                      }}
                      getOptionLabel={(option) => option.CompanyName}
                      renderOption={(props, option) => (
                        <Box component="li" {...props} key={option.AccountsId}>
                          {option.CompanyName}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Company Name"
                          variant="outlined"
                          required
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} style={{ marginBottom: "5px" }}>
                    <span style={{ fontSize: "14px", fontWeight: 500 }}>
                      Contact Name
                    </span>
                    <span style={{ color: "darkred", paddingLeft: "2px" }}>
                      *
                    </span>

                    <Autocomplete
                      disabled={mailData?.For == "2"}
                      size="small"
                      id="combo-box-demo"
                      value={contact}
                      options={contactDrop}
                      getOptionLabel={(option) => option.contactname}
                      renderOption={(props, option) => (
                        <Box component="li" {...props} key={option.ContactId}>
                          {option.contactname}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Contact Name"
                          variant="outlined"
                          required
                        />
                      )}
                      onChange={(event, newValue) => {
                        if (!newValue) {
                          productList(null);
                        } else {
                          productList(mailData.AppCode, newValue?.ContactId);
                        }
                        setContact(newValue);
                      }}
                    />
                  </Grid>
                </>
                {/* )} */}
                <Grid item xs={12} style={{ marginBottom: "5px" }}>
                  <span style={{ fontSize: "14px", fontWeight: 500 }}>
                    Ticket Source
                  </span>
                  <Autocomplete
                    size="small"
                    defaultValue={ticketDrop.TicketSourceId}
                    id="combo-box-demo"
                    value={ticketSource}
                    options={ticketDrop}
                    getOptionLabel={(option) => option.TicketSourceName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select"
                        variant="outlined"
                      />
                    )}
                    onChange={(event, newValue) => {
                      setTicketSource(newValue);
                    }}
                  />
                </Grid>
              </Grid>

              <div
                style={{
                  cursor: "pointer",
                  margin: "5px 0px 0px 0px",
                  padding: "0px 10px",
                }}
              >
                <span style={style5.title}>Department </span>
                <span style={{ color: "darkred" }}>*</span>
              </div>

              <Grid
                item
                xs={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: "5px 0px 0px 0px",
                  padding: "0px 10px",
                }}
              >
                <Autocomplete
                  fullWidth
                  size="small"
                  id="combo-box-demo"
                  value={Department}
                  options={DepartDrop}
                  getOptionLabel={(option) => option.DepartmentName}
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.DepartmentId}>
                      {option.DepartmentName}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Department"
                      variant="outlined"
                      required
                    />
                  )}
                  onChange={(event, newValue) => {
                    setDepartment(newValue);
                    handleDepartment(newValue);
                    assignList(mailData.AppCode, newValue?.DepartmentId);
                    issueList(mailData.AppCode, newValue?.DepartmentId);
                  }}
                />
              </Grid>

              <Grid
                container
                style={{
                  cursor: "pointer",
                  marginTop: "5px",
                  padding: "0px 10px",
                }}
              >
                <div>
                  <span style={style5.title}>
                    Issue <span style={{ color: "darkred" }}>*</span>
                  </span>
                </div>
              </Grid>

              <Grid
                item
                xs={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "0px 10px",
                }}
              >
                <Autocomplete
                  fullWidth
                  size="small"
                  id="combo-box-demo"
                  value={Issues}
                  options={IssueDrop}
                  getOptionLabel={(option) => option.IssueName}
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.IssueId}>
                      {option.IssueName}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Issue"
                      variant="outlined"
                      required
                    />
                  )}
                  onChange={(event, newValue) => {
                    setIssues(newValue);
                    handleIssues(newValue);
                    ETC(mailData.AppCode, newValue?.IssueId);
                  }}
                />
              </Grid>

              <Grid
                container
                xs={12}
                style={{
                  marginTop: "5px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Grid item style={{ cursor: "pointer", padding: "0px 10px" }}>
                  <span style={style5.title}>
                    Product <span style={{ color: "darkred" }}>*</span>
                  </span>
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "0px 10px",
                  }}
                >
                  <Autocomplete
                    fullWidth
                    size="small"
                    id="combo-box-demo"
                    value={Product}
                    options={productDrop}
                    getOptionLabel={(option) => option.ProductName}
                    renderOption={(props, option) => (
                      <Box component="li" {...props} key={option.ProductId}>
                        {option.ProductName}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Product"
                        variant="outlined"
                        required
                      />
                    )}
                    onChange={(event, newValue) => {
                      handleProduct(newValue);
                      setProduct(newValue);
                    }}
                  />
                </Grid>
              </Grid>

              <Grid container>
                <Grid
                  item
                  xs={12}
                  style={{ margin: "5px 0px 5px 0px", padding: "0px 10px" }}
                >
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    Assign To
                  </span>
                  <span style={{ color: "darkred", paddingLeft: "2px" }}>
                    *
                  </span>

                  <Autocomplete
                    size="small"
                    id="auto-complete"
                    options={assignDrop}
                    value={assign}
                    onChange={(event, newValue) => {
                      setAssign(newValue);
                      setAssignId(newValue?.UserId);
                    }}
                    getOptionLabel={(option) => option.UserName}
                    renderInput={(params) => (
                      <TextField {...params} placeholder="Select" />
                    )}
                    renderOption={(props, option) => {
                      const { key, ...optionProps } = props;
                      return (
                        <Box
                          key={key}
                          component="li"
                          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                          {...optionProps}
                        >
                          <img
                            src={option.ProfilePictureLink}
                            alt={option.UserName}
                            style={{
                              height: "30px",
                              width: "30px",
                              borderRadius: "50px",
                            }}
                          />
                          {option.UserName}
                        </Box>
                      );
                    }}
                  />
                </Grid>
              </Grid>

              <Grid
                item
                xs={12}
                style={{ margin: "5px 0px 5px 0px", padding: "0px 10px" }}
              >
                <span
                  style={{
                    fontWeight: 500,
                    fontSize: "14px",
                  }}
                >
                  {" "}
                  ETC <span style={{ color: "darkred" }}>*</span>
                </span>
                <Grid item xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDateTimePicker
                      value={DT}
                      onError={(newError) => setTimeError(newError)}
                      slotProps={{
                        textField: {
                          size: "small",
                        },
                      }}
                      onChange={(newValue) => {
                        setDT(newValue);
                      }}
                      disablePast={true}
                      views={["day", "month", "year", "hours", "minutes"]}
                      format="DD-MM-YYYY hh:mm A"
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>

              <Grid
                container
                xs={12}
                style={{ margin: "5px 0px 5px 0px", padding: "0px 10px" }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                  }}
                >
                  Tags
                </span>
                <Grid item xs={12}>
                  <Autocomplete
                    size="small"
                    multiple
                    value={selected}
                    onChange={(event, newValue) => {
                      if (typeof newValue === "string") {
                        setSelected({
                          TagName: newValue,
                        });
                      } else if (newValue && newValue?.inputValue) {
                        // Create a new value from the user input
                        setSelected({
                          TagName: newValue?.inputValue,
                        });
                      } else {
                        setSelected(newValue);
                      }
                    }}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);

                      const { inputValue } = params;
                      // Suggest the creation of a new value
                      const isExisting = options.some(
                        (option) => inputValue === option.TagName
                      );
                      if (inputValue !== "" && !isExisting) {
                        filtered.push({
                          inputValue,
                          TagName: `Add "${inputValue}"`,
                        });
                      }

                      return filtered;
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="free-solo-with-text-demo"
                    options={options}
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === "string") {
                        onkeydown = { handleKeyDown }; // setOptions(option);
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.inputValue;
                      }
                      onkeydown = { handleKeyDown };
                      return option.TagName;
                    }}
                    renderOption={(props, option) => (
                      <li {...props}>{option.TagName}</li>
                    )}
                    freeSolo
                    renderInput={(params) => (
                      <TextField {...params} placeholder="Select Or Add Tags" />
                    )}
                  />
                </Grid>
              </Grid>

              <Grid
                xs={12}
                container
                item
                style={{
                  margin: "10px 0px 10px 0px",
                  padding: "0px 10px",
                }}
              >
                <Grid item xs={12}>
                  <p
                    style={{
                      padding: "10px 15px",
                      background: "rgba(0, 113, 188, 0.1)",
                      margin: "0px",
                    }}
                  >
                    Description
                    <span style={{ color: "darkred", paddingLeft: "2px" }}>
                      *
                    </span>
                  </p>

                  <JoditEditor
                    ref={editor}
                    value={content}
                    config={{
                      readonly: true,
                    }}
                    onBlur={(e) =>
                      setContent(
                        e === "<p><br></p>" || e === "<p>&nbsp;<br></p>"
                          ? ""
                          : e.trim()
                      )
                    }
                  />
                </Grid>
                <Grid item style={{ margin: "10px 0px 0px 0px" }}>
                  <p
                    style={{
                      fontSize: "14px",
                      margin: "0px 0px 5px 0px",
                      fontWeight: 500,
                    }}
                  >
                    Attachments
                  </p>{" "}
                  {Attachementlinksobj.map((x) => {
                    return (
                      <div
                        style={{
                          cursor: "pointer",
                          alignItems: "center",
                          display: "flex",
                        }}
                      >
                        <Tooltip
                          style={{ paddingRight: "5px" }}
                          title={
                            <div style={{ height: "102px", width: "180px" }}>
                              <img
                                src={x.s3path}
                                style={{
                                  width: "180px",
                                  position: "absolute",
                                  rigth: "80%",
                                }}
                              />
                            </div>
                          }
                        >
                          <Link to={x.s3path} target="blank">
                            <ImageIcon
                              style={{
                                width: "20px",
                                height: "20px",
                                color: " rgb(45, 113, 188)",
                              }}
                            />

                            {x.filename}
                          </Link>
                        </Tooltip>
                      </div>
                    );
                  })}
                  <FileAttachment
                    setAttachmentLink={setAttachmentLink}
                    AttachmentLink={AttachmentLink}
                    refresh={refresh}
                    setRefresh={setRefresh}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                md={11}
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "15px",
                  margin: "10px 0px",
                  borderTop: "1px solid rgb(0,0,0,0.1)",
                }}
              >
                <Button
                  size="small"
                  disabled={Buttondisable}
                  variant="contained"
                  style={{
                    maxHeight: "22px",
                    minHeight: "22px",
                    textTransform: "none",
                    padding: "10px 20px",
                    margin: "5px 0px 0px 0px",
                  }}
                  onClick={() => {
                    ClosecreateTicket();
                    SetButtondisable(true);
                  }}
                >
                  Save & Close
                </Button>
              </Grid>

              <ToastContainer
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                fontSize={"14px"}
                fontWeight={"600"}
                color={"#232323"}
              />
            </Grid>
          ) : (
            <Grid
              item
              xs={12}
              sx={{
                textAlign: "center",
                padding: "10px",
                height: "90vh",
                minHeight: "90vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography>Ticket has already assigned</Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
}

export default EmailToTicketForm;

const style5 = {
  cards: {
    background: "#F4F4F4",
    boxShadow:
      "1px 1px 2px rgba(255, 255, 255, 0.3), -1px -1px 2px rgba(176, 176, 176, 0.5), inset -3px 3px 6px rgba(176, 176, 176, 0.2), inset 3px -3px 6px rgba(176, 176, 176, 0.2), inset -3px -3px 6px rgba(255, 255, 255, 0.9), inset 3px 3px 8px rgba(176, 176, 176, 0.9)",
    borderRadius: "10px",
    fontSize: "14px",
    border: "hidden",
    textTransform: "none",
    fontWeight: 400,

    cursor: "pointer",
    padding: "20px 15px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  cardsActive: {
    boxShadow:
      "1px 1px 2px rgba(255, 255, 255, 04), -1px -1px 2px rgba(176, 176, 176, 0.5), inset -3px 3px 6px rgba(176, 176, 176, 0.2), inset 3px -3px 6px rgba(176, 176, 176, 0.2), inset -3px -3px 6px rgba(255, 255, 255, 0.9), inset 3px 3px 8px rgba(176, 176, 176, 0.9)",
    borderRadius: "10px",
    borderBottom: "4px solid #0071BC",
    background: "rgba(10, 124, 198, 0.1)",
    fontSize: "14px",
    textTransform: "none",
    fontWeight: 500,
    cursor: "pointer",
    padding: "20px 15px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  title: {
    fontSize: "14px",
    fontWeight: 500,
    margin: "10px 0px 10px 0px",
  },
  title2: {
    color: "#0071BC",
    fontSize: "22px",
    fontWeight: 600,
    paddingLeft: "5px",
  },
  Commentimg: {
    height: "29px",
    width: "29px",
  },
};
const formControlLabelStyle = {
  "& .MuiFormControlLabel-label": {
    fontSize: "14px",
  },
};

const stylebox = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "white",
  boxShadow: 24,
  pt: 2,
  pb: 2,
  pl: 4,
  pr: 4,
  borderRadius: "10px",
  outline: "transparent",
  maxHeight: "60vh",
  overflowY: "auto",
  overflowX: "hidden",
};
